import { CustomEventWithDetail, html, on, View } from 'rune-ts';
import { preventEscape } from '../../../../shared/util/preventEscape';
import { Confirm } from '../Confirm/Confirm';
import klass from './CreatorItem.module.scss';
import { htmlIf } from '../../../../shared/util';
import { staticTypo, typo } from '../../../../shared/typography/typo';
import { CreatorTypeS } from '../../../../features/Creator/outbound/share';
import { HeartFillIcon, MShopThinIcon } from '../../atoms/Icon';
import { UtilS } from '../../../../../../modules/Util/S/Function/module/UtilS';
import { MarketplaceAuthF } from '../../../../../../modules/Marketplace/Auth/F/Function/module/MarketplaceAuthF';
import axios from 'axios';
import { ConfigSentryF } from '../../../../../../modules/Config/Sentry/F/Function/module/ConfigSentryF';
import { MShopUtilF } from '../../../../../../modules/MShop/Util/F/Function/module/MShopUtilF';
import { getResizedUrl } from '../../../../shared/util/image';

export class CreatorItemLikeToggleEvent extends CustomEventWithDetail<{
  toggleLikeButton: () => void;
}> {}

interface CreatorItemOption {
  klass?: string;
}

export class CreatorItem extends View<CreatorTypeS.CreatorCardType> {
  state: CreatorItemOption & {
    // FIXME
  };

  constructor(data: CreatorTypeS.CreatorCardType, option: CreatorItemOption = {}) {
    super(data);

    this.state = {
      klass: option.klass,
    };
  }

  override template() {
    const { name, thumbnail_img, domain_name, like_count, is_liked } = this.data;

    return html`
      <div class="${klass.container}">
        <div class="${klass.thumb}">
          <a href="/${ET.lang}/${domain_name}">
            <img
              src="${getResizedUrl({
                url: thumbnail_img || '',
                width: 174 * 2,
                format: 'webp',
                quality: 70,
              })}"
              alt="${name}"
              class="${klass.thumb_img}"
            />
          </a>
        </div>
        <div class="${klass.name} ${typo('16_bold')}">
          <a href="/${ET.lang}/${domain_name}">
            <span class="${klass.name_txt}">${html.preventEscape(name ?? '')}</span>
            <span class="${klass.mshop_thin_icon}">${MShopThinIcon}</span>
          </a>
        </div>
        <div class="${klass.like_area}">
          <button type="button" class="${klass.like_btn} ${htmlIf(klass.active, is_liked)}">
            <span class="${klass.like}">${HeartFillIcon}</span>
            <span
              class="${klass.like_count} ${staticTypo('unica_14_regular')} ${htmlIf(klass.active, is_liked)}"
              >${UtilS.commify(like_count)}</span
            >
          </button>
        </div>
      </div>
    `;
  }

  @on('click', `.${klass.like_btn}`)
  private _onLikeClick() {
    this.dispatchEvent(CreatorItemLikeToggleEvent, {
      bubbles: true,
      detail: {
        toggleLikeButton: this.toggleLikeButton.bind(this),
      },
    });
  }

  toggleLikeButtonStyle() {
    this.data.like_count = this.data.is_liked ? this.data.like_count - 1 : this.data.like_count + 1;
    this.data.is_liked = !this.data.is_liked;
    this.redraw();
  }

  async toggleLikeButton() {
    if (!box.sel('is_user->id') || box.sel('is_user->type') == 'TEMP') {
      if (
        await Confirm.open({
          title: ET('mps2::login::need_login::title'),
          message: preventEscape(ET('mps2::login::need_login::message')),
          confirmText: ET('mps2::login::login'),
          cancelText: ET('mps2::signup::close'),
        })
      ) {
        return MarketplaceAuthF.goSignIn();
      }
      return;
    }
    const already_like = !!this.data.is_liked;

    this.toggleLikeButtonStyle();

    try {
      await axios.post(UtilS.makeApiUrl(`/:lang/@api/stores_like`, { lang: T.lang }), {
        already_like,
        store_id: this.data.id,
      });
      MShopUtilF.popToastMsg(
        already_like
          ? T('mshop::좋아요 목록에서 삭제되었습니다.')
          : T('mshop::좋아요 목록에 추가되었습니다.'),
        already_like ? 'error' : 'store_like',
      );
    } catch (err) {
      this.toggleLikeButtonStyle();
      ConfigSentryF.error(err);
    }
  }
}
